export * from "-!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/framevuerk-builder/node_modules/pug-html-loader/lib/index.js!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/index.js??vue-loader-options!./fvSidebar.vue?vue&type=template&id=1ace9a2c&lang=pug&"


//////////////////
// WEBPACK FOOTER
// ./src/components/fvSidebar.vue?vue&type=template&id=1ace9a2c&lang=pug&
// module id = 99
// module chunks = 0 1